import * as z from 'zod';

export const recruitingQueryLinkerSchema = z.object({
  id: z.number(),
  first_name: z.string().min(3),
  last_name: z.string().min(3),
});

export type RecruitingQueryLinkerSchema = z.infer<typeof recruitingQueryLinkerSchema>;
